import { Reducer } from "redux";
import { IFeedbackState, FeedbackActions, FeedbackActionTypes } from "./types";
import { getIsFeedbackAvailableFromStorage } from "../../hooks/useFeedback";

const initialState: IFeedbackState = {
  showFeedback: false,
  isFeedbackAvailable: getIsFeedbackAvailableFromStorage()
};

export const feedbackReducer: Reducer<IFeedbackState, FeedbackActions> = (state = initialState, action) => {
  switch (action.type) {
    case FeedbackActionTypes.SET_FEEDBACK_STATE: {
      const showFeedback = action.payload;

      return {
        ...state,
        showFeedback
      };
    }
    case FeedbackActionTypes.SET_FEEDBACK_AVAILABLE: {
      return {
        ...state,
        isFeedbackAvailable: action.payload
      };
    }
    default:
      return state;
  }
};
